    // Deal section: click a thumbnail to swap the main product image
    (function () {
      var mainImg = document.getElementById('dealMainImg');
      var thumbs = document.querySelectorAll('.thumbs .thumb');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full') || thumb.src;
          if (mainImg.src.indexOf(fullSrc) !== -1) return;

          // quick crossfade
          mainImg.classList.add('fading');
          setTimeout(function () {
            mainImg.src = fullSrc;
            mainImg.alt = thumb.alt;
            mainImg.classList.remove('fading');
          }, 150);

          // toggle active state
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        });
      });
    })();

    // CTA buttons: smooth-scroll to a target section without adding a
    // "#hash" to the URL (no history entry, no visible hash in the address bar)
    (function () {
      var ctaButtons = document.querySelectorAll('[data-scroll-target]');
      ctaButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-scroll-target');
          var targetEl = document.getElementById(targetId);
          if (targetEl) {
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    })();

    // Upsell modal: opened by the pricing-card "Buy Now" buttons.
    // Closed by clicking outside the modal box, pressing Escape,
    // or using either of the in-modal actions. There is no "X" close button
    // by design — clicking the dimmed backdrop is the intended way out.
    (function () {
      var overlay = document.getElementById('upsellOverlay');
      var modalBox = overlay.querySelector('.modal-box');
      var openTriggers = document.querySelectorAll('[data-open-upsell]');
      var skipBtn = document.getElementById('upsellSkip');
      var addToCartBtn = document.getElementById('upsellAddToCart');

      function openModal() {
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      }

      openTriggers.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openModal();
        });
      });

      // Click on the dimmed backdrop (not the modal box itself) closes it
      overlay.addEventListener('mousedown', function (e) {
        if (!modalBox.contains(e.target)) {
          closeModal();
        }
      });

      // Escape key closes it too
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('open')) {
          closeModal();
        }
      });

      // "Skip & Checkout" closes the modal and continues to checkout
      skipBtn.addEventListener('click', function () {
        closeModal();
        var guaranteeEl = document.getElementById('guarantee');
        if (guaranteeEl) guaranteeEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // "Add to Cart" accepts the upsell and closes the modal
      addToCartBtn.addEventListener('click', function () {
        closeModal();
        var guaranteeEl = document.getElementById('guarantee');
        if (guaranteeEl) guaranteeEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    })();